import { render } from "./px-radio-group.vue?vue&type=template&id=9d60952c&ts=true"
import script from "./px-radio-group.vue?vue&type=script&lang=ts"
export * from "./px-radio-group.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__